import React, { useState, useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import InputField from '../components/ui/InputField';
import TextAreaField from '../components/ui/TextAreaField';
import Button from '../components/ui/Button';

const TerziReportForm = ({ onDataChange }) => {
  const { t } = useTranslation();
  const [shopInfo, setShopInfo] = useState({
    shopName: '',
    contactInfo: '',
    address: '',
    customerName: ''
  });

  const [items, setItems] = useState([
    { itemName: '', category: 'Clothing', quantity: 1, unitPrice: 0, total: 0 }
  ]);

  const [notes, setNotes] = useState('');

  // YENİ: Tax Rate (%) opsiyonel
  const [taxRate, setTaxRate] = useState(0);

  useEffect(() => {
    const subtotal = items.reduce((sum, item) => sum + item.total, 0);
    const tax = taxRate > 0 ? subtotal * (taxRate / 100) : 0;
    const grandTotal = subtotal + tax;

    onDataChange({
      ...shopInfo,
      items,
      notes,
      subtotal,
      taxRate,
      tax,
      grandTotal,
      date: new Date().toLocaleDateString()
    });
  }, [shopInfo, items, notes, taxRate, onDataChange]);

  const handleItemChange = (index, field, value) => {
    const newItems = [...items];
    newItems[index][field] = value;
    if (field === 'quantity' || field === 'unitPrice') {
      newItems[index].total = newItems[index].quantity * newItems[index].unitPrice;
    }
    setItems(newItems);
  };

  const subtotal = items.reduce((sum, item) => sum + item.total, 0);
  const tax = subtotal * 0.16;
  const grandTotal = subtotal + tax;

  return (
    <div className="bg-white dark:bg-gray-800 rounded-xl p-6 lg:p-8 border border-gray-200 dark:border-gray-700 shadow-sm space-y-8">
      <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
        <InputField label="Boutique/Shop Name" name="shopName" value={shopInfo.shopName} onChange={(e) => setShopInfo({ ...shopInfo, shopName: e.target.value })} placeholder="Shop name" required />
        <InputField label="Customer Name" name="customerName" value={shopInfo.customerName} onChange={(e) => setShopInfo({ ...shopInfo, customerName: e.target.value })} placeholder="Customer name" />
        <InputField label={t('form.contactInfo')} name="contactInfo" value={shopInfo.contactInfo} onChange={(e) => setShopInfo({ ...shopInfo, contactInfo: e.target.value })} placeholder="Contact info" />
        <div className="md:col-span-2">
          <TextAreaField label={t('form.address')} name="address" value={shopInfo.address} onChange={(e) => setShopInfo({ ...shopInfo, address: e.target.value })} placeholder="Shop address" rows={2} />
        </div>
      </div>

      <div>
        <h3 className="text-xl font-bold text-[#111418] dark:text-white mb-4">Sales Items</h3>
        <div className="overflow-x-auto">
          <table className="w-full text-left">
            <thead className="border-b border-gray-200 dark:border-gray-700">
              <tr>
                <th className="p-3 text-sm font-medium text-gray-600 dark:text-gray-400">Item Name</th>
                <th className="p-3 text-sm font-medium text-gray-600 dark:text-gray-400">Category</th>
                <th className="p-3 text-sm font-medium text-gray-600 dark:text-gray-400">Qty</th>
                <th className="p-3 text-sm font-medium text-gray-600 dark:text-gray-400">Unit Price</th>
                <th className="p-3 text-sm font-medium text-gray-600 dark:text-gray-400 text-right">Total</th>
                <th className="p-3 w-12"></th>
              </tr>
            </thead>
            <tbody>
              {items.map((item, index) => (
                <tr key={index} className="border-b border-gray-200 dark:border-gray-700">
                  <td className="p-2"><input className="form-input w-full bg-transparent border-0 focus:ring-0 p-2" type="text" value={item.itemName} onChange={(e) => handleItemChange(index, 'itemName', e.target.value)} placeholder="e.g., Dress, Shoes" /></td>
                  <td className="p-2">
                    <select className="form-select w-full bg-transparent border-0 focus:ring-0 p-2" value={item.category} onChange={(e) => handleItemChange(index, 'category', e.target.value)}>
                      <option>Clothing</option>
                      <option>Accessories</option>
                      <option>Shoes</option>
                      <option>Bags</option>
                      <option>Other</option>
                    </select>
                  </td>
                  <td className="p-2"><input className="form-input w-20 bg-transparent border-0 focus:ring-0 p-2 text-center" type="number" min="1" value={item.quantity} onChange={(e) => handleItemChange(index, 'quantity', parseFloat(e.target.value) || 0)} /></td>
                  <td className="p-2"><input className="form-input w-28 bg-transparent border-0 focus:ring-0 p-2 text-right" type="number" min="0" step="0.01" value={item.unitPrice} onChange={(e) => handleItemChange(index, 'unitPrice', parseFloat(e.target.value) || 0)} /></td>
                  <td className="p-2 text-right font-medium text-[#111418] dark:text-gray-100">${item.total.toFixed(2)}</td>
                  <td className="p-2 text-center"><button onClick={() => setItems(items.filter((_, i) => i !== index))} className="text-gray-400 hover:text-red-500" disabled={items.length === 1}><span className="material-symbols-outlined text-xl">delete</span></button></td>
                </tr>
              ))}
            </tbody>
          </table>
          <Button onClick={() => setItems([...items, { itemName: '', category: 'Clothing', quantity: 1, unitPrice: 0, total: 0 }])} variant="ghost" icon="add_circle" className="mt-4">{t('form.addRow')}</Button>
        </div>
      </div>

      {/* Tax Rate (%) alanı */}
      <div className="mb-6">
        <InputField
          label="Tax Rate (%) - Optional"
          name="taxRate"
          type="number"
          min="0"
          max="100"
          step="0.1"
          value={taxRate}
          onChange={e => setTaxRate(parseFloat(e.target.value) || 0)}
          placeholder="0 (No Tax)"
        />
        <p className="text-xs text-gray-500 dark:text-gray-400 mt-1">
          Leave 0 for no tax. Example: 16 (Kenya), 18 (Turkey), 5 (UAE)
        </p>
      </div>

      <div className="flex justify-end">
        <div className="w-full max-w-sm space-y-3">
          <div className="flex justify-between items-center">
            <span className="text-gray-600 dark:text-gray-400">{t('form.subtotal')}</span>
            <span className="font-medium text-[#111418] dark:text-gray-100">${subtotal.toFixed(2)}</span>
          </div>
          {/* Sadece taxRate > 0 ise göster */}
          {taxRate > 0 && (
            <div className="flex justify-between items-center">
              <span className="text-gray-600 dark:text-gray-400">{t('form.tax')} ({taxRate}%)</span>
              <span className="font-medium text-[#111418] dark:text-gray-100">${(subtotal * (taxRate / 100)).toFixed(2)}</span>
            </div>
          )}
          <div className="flex justify-between items-center pt-3 border-t border-gray-200 dark:border-gray-700">
            <span className="text-lg font-bold text-[#111418] dark:text-gray-100">{t('form.grandTotal')}</span>
            <span className="text-lg font-bold text-primary">${(subtotal + (taxRate > 0 ? subtotal * (taxRate / 100) : 0)).toFixed(2)}</span>
          </div>
        </div>
      </div>

      <TextAreaField label={t('form.notes')} value={notes} onChange={(e) => setNotes(e.target.value)} placeholder="Customer preferences, tailoring details..." rows={3} />
    </div>
  );
};

export default TerziReportForm;
